import { SceneSetters } from "../../types";
import { GameScene } from "./GameScene";
import { EndScene } from "./EndScene";

export function generateScenes(setters: SceneSetters): Phaser.Scene[] {
  return [GameScene, EndScene].map((Scene) => new Scene(setters));
}
